// extracted by mini-css-extract-plugin
export var container = "_i4-0";
export var content = "_i4-3";
export var customerTitle = "_i4-4";
export var empty = "_i4-5";
export var gray = "_i4-6";
export var header = "_i4-7";
export var info = "_i4-8";
export var loading = "_i4-2";
export var loadingCard = "_i4-9";
export var oneLine = "_i4-a";
export var personName = "_i4-e";
export var pillContainer = "_i4-b";
export var selected = "_i4-1";
export var text = "_i4-c";
export var twoLines = "_i4-d";
export var unread = "_i4-f";
export var unreadIndicator = "_i4-g";